import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '../../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../../ui/sheet';
import { Menu, Phone } from 'lucide-react';

function MobileNavButton({ active, onClick, children, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`text-left px-4 py-2.5 rounded-lg text-[15px] font-medium transition-colors ${
        active ? 'bg-primary/10 text-primary' : 'text-foreground hover:bg-[hsl(var(--bone-2))]'
      }`}
    >
      {children}
    </button>
  );
}

export default function MobileMenu({
  open,
  onOpenChange,
  groups,
  isHome,
  activeSection,
  onScrollItemClick,
  onPageItemClick,
}) {
  const location = useLocation();

  const isItemActive = (item) =>
    item.type === 'page' ? location.pathname === item.path : isHome && activeSection === item.id;

  return (
    <div className="lg:hidden">
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" data-testid="site-nav-mobile-toggle" aria-label="Open navigation menu">
            <Menu className="w-5 h-5" aria-hidden="true" />
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-[320px] bg-background overflow-y-auto">
          <div className="mt-6 mb-6 pb-6 border-b border-bone-2">
            <p className="font-display text-xl text-foreground">Ozark Mountain</p>
            <p className="font-mono text-[10px] tracking-[0.22em] text-muted-foreground uppercase mt-1">
              Construction Co.
            </p>
          </div>
          <div className="flex flex-col gap-0.5">
            {groups.map((g) => {
              if (!g.items) {
                return (
                  <MobileNavButton
                    key={g.key}
                    active={location.pathname === g.path}
                    onClick={() => onPageItemClick(g.path)}
                    testId={`site-nav-mobile-${g.key}-link`}
                  >
                    {g.label}
                  </MobileNavButton>
                );
              }
              return (
                <div key={g.key} className="pt-3 first:pt-0">
                  <p className="px-4 pb-1 font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
                    {g.label}
                  </p>
                  {g.items.map((item) => (
                    <MobileNavButton
                      key={item.label}
                      active={isItemActive(item)}
                      onClick={() => (item.type === 'scroll' ? onScrollItemClick(item.id) : onPageItemClick(item.path))}
                      testId={item.testId ? `${item.testId}-mobile` : `site-nav-mobile-${g.key}-${item.id || item.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {item.label}
                    </MobileNavButton>
                  ))}
                </div>
              );
            })}
            <div className="mt-6 px-4">
              <a href="tel:5014507538">
                <Button className="w-full gap-2">
                  <Phone className="w-4 h-4" />
                  (501) 450-7538
                </Button>
              </a>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
